function renderResolveSelectFieldsSourceDynamicRowsTemplate({
  selectOptionsTableVar
}: {
  selectOptionsTableVar: string
}): string {
  return `
  const dynamicRows = await db
    .select({
      fieldName: ${selectOptionsTableVar}.fieldName,
      label: ${selectOptionsTableVar}.label,
      value: ${selectOptionsTableVar}.value
    })
    .from(${selectOptionsTableVar})

  for (const row of dynamicRows) {
    labelMaps[row.fieldName] ??= {}
    labelMaps[row.fieldName][row.value] = row.label
  }
`
}

function renderResolveSelectFieldsSourceStaticSelectOptionLabelsTemplate({
  staticLabelMaps,
  exportedExport,
  singular,
  dynamicRowsBlock,
  assignments
}: {
  staticLabelMaps: string
  exportedExport: string
  singular: string
  dynamicRowsBlock: string
  assignments: string
}): string {
  return `const STATIC_SELECT_OPTION_LABELS = {
${staticLabelMaps}
} satisfies Record<string, Record<string, string>>

function cloneSelectOptionLabelMaps(): Record<string, Record<string, string>> {
  return Object.fromEntries(
    Object.entries(STATIC_SELECT_OPTION_LABELS).map(([fieldName, labels]) => [
      fieldName,
      { ...labels }
    ])
  )
}

function toSelectOptionValues(value: unknown, labels: Record<string, string>): SelectOptionValue[] {
  const values = Array.isArray(value) ? value : value ? [value] : []

  return values
    .filter((item): item is string => typeof item === 'string' && item.length > 0)
    .map((item) => ({
      label: labels[item] ?? item,
      value: item
    }))
}

function resolveSelectFieldPath(
  source: Record<string, unknown>,
  path: readonly string[],
  labels: Record<string, string>
): void {
  const [fieldName, ...rest] = path
  if (!fieldName) return

  if (rest.length === 0) {
    source[fieldName] = toSelectOptionValues(source[fieldName], labels)
    return
  }

  const value = source[fieldName]
  if (Array.isArray(value)) {
    for (const item of value) {
      if (item && typeof item === 'object') {
        resolveSelectFieldPath(item as Record<string, unknown>, rest, labels)
      }
    }
    return
  }

  if (value && typeof value === 'object') {
    resolveSelectFieldPath(value as Record<string, unknown>, rest, labels)
  }
}

${exportedExport}async function resolve${singular}SelectFields(rows: ${singular}[]): Promise<${singular}[]> {
  if (rows.length === 0) return rows

  const labelMaps = cloneSelectOptionLabelMaps()
${dynamicRowsBlock}
  for (const row of rows) {
    const source = row as unknown as Record<string, unknown>
${assignments}
  }

  return rows
}`
}

export function renderSelectFieldsResolverRenderer(
  request:
    | {
        kind: 'renderResolveSelectFieldsSourceDynamicRowsTemplate'
        props: {
          selectOptionsTableVar: string
        }
      }
    | {
        kind: 'renderResolveSelectFieldsSourceStaticSelectOptionLabelsTemplate'
        props: {
          staticLabelMaps: string
          exportedExport: string
          singular: string
          dynamicRowsBlock: string
          assignments: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderResolveSelectFieldsSourceDynamicRowsTemplate':
      return renderResolveSelectFieldsSourceDynamicRowsTemplate(request.props)
    case 'renderResolveSelectFieldsSourceStaticSelectOptionLabelsTemplate':
      return renderResolveSelectFieldsSourceStaticSelectOptionLabelsTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
